module.exports = __webpack_public_path__ + "assets/img/spinner.162eba4d.svg";